function notInitialized() {
  throw new Error('Audio is not initialized');
}

export default {
  create: notInitialized,
};
